import React from 'react';
import { Search, Filter } from 'lucide-react';

interface EventsHeaderProps {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  showUpcomingOnly: boolean;
  setShowUpcomingOnly: (show: boolean) => void;
  filteredEvents: any[];
  totalEvents: number;
}

const EventsHeader: React.FC<EventsHeaderProps> = ({
  searchTerm,
  setSearchTerm,
  showUpcomingOnly,
  setShowUpcomingOnly,
  filteredEvents,
  totalEvents
}) => {
  return (
    <>
      <h1 className="text-4xl font-bold text-white mb-8">Racing Events</h1>

      {/* Search and Filter Controls */}
      <div className="mb-8 flex flex-wrap items-center gap-4">
        {/* Search Bar */}
        <div className="relative w-64">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search events..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full bg-zinc-900 text-white pl-9 pr-3 py-2 rounded-lg focus:ring-2 focus:ring-primary-500 focus:outline-none border border-zinc-700 text-sm"
          />
        </div>

        {/* Filter Toggle */}
        <button
          onClick={() => setShowUpcomingOnly(!showUpcomingOnly)}
          className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors flex items-center gap-2 ${
            showUpcomingOnly
              ? 'bg-primary-600 text-white'
              : 'bg-zinc-800 text-gray-300 hover:bg-zinc-700'
          }`}
        >
          <Filter className="h-4 w-4" />
          {showUpcomingOnly ? 'Upcoming Only' : 'All Events'}
        </button>

        {/* Event count display */}
        <div className="text-gray-400 text-sm ml-auto">
          Showing {filteredEvents.length} of {totalEvents} events
          {searchTerm && (
            <span className="ml-2 text-primary-400">
              matching "{searchTerm}"
            </span>
          )}
        </div>
      </div>
    </>
  );
};

export default EventsHeader;